module.exports = __webpack_public_path__ + "img/brand_Logos.89bdc629.png";